import React from "react";
import { analytics } from "../../services";
import CustomInput from "../../components/DesignSystem/CustomInput";
import MaskedInput from "../../components/DesignSystem/MaskedInput";
import { states } from "./states";
import {
  Select,
  Box,
  Card,
  CardHeader,
  CardBody,
  Text,
  Button,
  Center,
  Alert,
  AlertIcon,
  AlertDescription,
} from "@chakra-ui/react";

class liveCheck extends React.Component {
  constructor(props) {
    super(props);

    this.emailInputRef = React.createRef();

    this.state = {
      emailError: false,
      isValidPassword: false,
      phoneError: false,
      isLoading: false,
    };

    this.handleButtonClick = this.handleButtonClick.bind(this);
    this.handlePasswordValidationChange =
      this.handlePasswordValidationChange.bind(this);
  }

  handlePasswordValidationChange(isValid) {
    this.setState({ isValidPassword: isValid });
  }

  checkEmail = (input) => {
    return /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/.test(
      input
    );
  };
  checkFirstName = (input) => {
    return /[A-Za-z].*[A-Za-z]/.test(input);
  };

  handleInputBlur() {
    if (this.checkEmail(this.props.email)) {
      this.setState({ emailError: false });
    } else if (this.props.email !== "") {
      this.setState({ emailError: true });
    }
  }

  handlePhoneInputBlur() {
    if (
      this.props.mobile.length > 13 ||
      this.props.mobile === "(" ||
      this.props.mobile === ""
    ) {
      this.setState({ phoneError: false });
    } else {
      this.setState({ phoneError: true });
    }
  }

  singleUpdate() {
    if (this.props.currentStep === 2) {
      analytics.track("Verification", "Wizard", { page: 2 });

      //Allows for use on single DidUpdate
      this.singleUpdate = function () {};
    }
  }

  handleButtonClick() {
    if (this.emailInputRef.current) {
      this.emailInputRef.current.focus();
    }
  }

  componentDidMount() {
    this.handleInputBlur();
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.failedVerification ||
      prevProps.verificationAttempts !== this.props.verificationAttempts ||
      (this.props.emailIsUnique === false && this.state.isLoading)
    ) {
      window.scrollTo({ top: 0, behavior: "smooth" });
      if (this.state.isLoading) {
        this.setState({ isLoading: false });
      }
    }

    this.singleUpdate();
  }

  render() {
    if (this.props.currentStep !== 2) {
      return null;
    }

    const isButtonEnabled =
      this.checkFirstName(this.props.firstName) &&
      this.state.isValidPassword &&
      this.checkEmail(this.props.email) &&
      this.props.streetAddress?.length > 1 &&
      this.props.city?.length > 1 &&
      this.props.stateCode?.length > 1 &&
      this.props.zipCode?.length > 4 &&
      (this.props.mobile.length > 13 ||
        this.props.mobile === "(" ||
        this.props.mobile === "") &&
      !this.props.failedVerification;
    const showVerificationBox = this.checkEmail(this.props.email);

    return (
      <Box bg="#EBF9FF">
        <Center>
          <Card mt={10} mb={10} maxW={"480px"} boxShadow="xl" p={10}>
            <CardHeader mb={-5}>
              <Text textStyle="t6" as="b" color="pb100">
                Complete your profile
              </Text>
            </CardHeader>

            <CardBody>
              <Text textStyle="b2">
                Enter the information below to validate your account and
                complete your profile.
              </Text>
              {this.props.emailIsUnique === false && (
                <Box>
                  <Alert mt={5} variant="error" status="error">
                    {" "}
                    <AlertIcon />
                    <Box>
                      <AlertDescription>
                        This email is already linked to another account. Please
                        use a different email.
                      </AlertDescription>
                    </Box>
                  </Alert>
                </Box>
              )}
              {(this.props.verificationAttempts > 0 ||
                this.props.failedVerification) && (
                <Box mb={5}>
                  <Alert mt={5} variant="error" status="error">
                    {" "}
                    <AlertIcon />
                    <Box>
                      <AlertDescription>
                        {this.props.failedVerification && (
                          <Text textStyle={"b3"}>
                            We still couldn’t validate your account. Please give
                            us a call at{" "}
                            <a
                              style={{
                                textDecoration: "underline",
                                color: "#0065E0",
                              }}
                              href="tel:8339071737"
                            >
                              {" "}
                              (833) 907-1737
                            </a>{" "}
                            to help you with this step.
                          </Text>
                        )}
                        {this.props.verificationAttempts > 0 &&
                          !this.props.failedVerification &&
                          "We couldn't validate your account with the information you entered. Check if you entered your information correctly and try again."}
                      </AlertDescription>
                    </Box>
                  </Alert>
                </Box>
              )}
              <Box mt={8}>
                <label htmlFor="firstName" className="visually-hidden">
                  First Name
                </label>
                <CustomInput
                  id="firstName"
                  type="letters"
                  name="firstName"
                  inputTitle="First Name"
                  isRequired
                  onChange={this.props.handleChange}
                  value={this.props.firstName}
                ></CustomInput>
              </Box>
              <Box mt={8}>
                <label htmlFor="email" className="visually-hidden">
                  Email
                </label>
                <CustomInput
                  inputRef={this.emailInputRef}
                  id="email"
                  name="email"
                  inputTitle="Email"
                  isRequired
                  isInvalid={this.state.emailError}
                  error={this.state.emailError && "Please enter a valid email"}
                  description="You'll use this email to sign in to your account."
                  onChange={this.props.handleChange}
                  value={this.props.email}
                  onBlur={() => this.handleInputBlur()}
                ></CustomInput>
              </Box>
              <Box mt={8}>
                <label htmlFor="password" className="visually-hidden">
                  Create a Password
                </label>
                <MaskedInput
                  inputTitle="Create a Password"
                  isRequired
                  id="password"
                  name="password"
                  type="password"
                  toggleButton
                  value={this.props.password}
                  onChange={this.props.handleChange}
                  onPasswordValidationChange={
                    this.handlePasswordValidationChange
                  }
                ></MaskedInput>
              </Box>
              <Box mt={8}>
                <CustomInput
                  id="mobile"
                  name="mobile"
                  isInvalid={this.state.phoneError}
                  error={
                    this.state.phoneError && "Please enter a valid phone number"
                  }
                  inputTitle="Phone (optional)"
                  type="phone"
                  description="To keep you up-to-date with our latest promotions"
                  value={this.props.mobile}
                  onChange={(event) => {
                    this.props.handleChange(event);
                  }}
                  onBlur={() => this.handlePhoneInputBlur()}
                />
              </Box>
              <Box mt={8} mb={3}>
                <Text textStyle="b1" as={"b"}>
                  Mailing Address
                </Text>
              </Box>
              <Box mt={8}>
                <label htmlFor="streetAddress" className="visually-hidden">
                  Street Address
                </label>
                <CustomInput
                  inputTitle="Street Address"
                  isRequired
                  type="alphanumeric"
                  id="streetAddress"
                  name="streetAddress"
                  value={this.props.streetAddress}
                  onChange={this.props.handleChange}
                ></CustomInput>
              </Box>{" "}
              <Box mt={8}>
                <label htmlFor="city" className="visually-hidden">
                  City
                </label>
                <CustomInput
                  inputTitle="City"
                  isRequired
                  type="alphanumeric"
                  id="city"
                  name="city"
                  value={this.props.city}
                  onChange={this.props.handleChange}
                ></CustomInput>
              </Box>
              <Box p={5} mt={3}>
                <Box mb={2}>
                  <Text textStyle="b2" ml={-5}>
                    State{" "}
                    <Text as="span" color="sr60">
                      *
                    </Text>
                  </Text>{" "}
                </Box>
                <Box maxW={"260px"}>
                  <Select
                    ml={-5}
                    aria-label="stateselection"
                    placeholder=" "
                    id="stateCode"
                    name="stateCode"
                    borderColor="pg50"
                    borderRadius={".25rem"}
                    onChange={this.props.handleChange}
                    value={this.props.stateCode}
                  >
                    {states.map((state, index) => (
                      <option key={index} value={state}>
                        {state}
                      </option>
                    ))}
                  </Select>
                </Box>
              </Box>
              <Box mt={5}>
                {" "}
                <Box maxW={"260px"}>
                  <label htmlFor="zipCode" className="visually-hidden">
                    ZIP Code
                  </label>
                  <CustomInput
                    maxLength={5}
                    inputTitle="ZIP Code"
                    isRequired
                    id="zipCode"
                    type="numbers"
                    name="zipCode"
                    value={this.props.zipCode}
                    onChange={this.props.handleChange}
                  ></CustomInput>
                </Box>
              </Box>
              {showVerificationBox && (
                <Center>
                  <Box maxW={"100%"} bg="#F5F5F5" p={5} m={5}>
                    <Box textAlign="center">
                      Verification email will be sent to{" "}
                      <strong>{this.props.email}</strong>
                    </Box>

                    <Box>
                      <Button
                        mt={3}
                        variant="outline"
                        size="xs"
                        onClick={this.handleButtonClick}
                        w="100%"
                      >
                        Change
                      </Button>
                    </Box>
                  </Box>
                </Center>
              )}
            </CardBody>

            <Box>
              <Center>
                <Button
                  w="100%"
                  m={4}
                  mb={8}
                  mt={10}
                  onClick={() => {
                    this.setState({ isLoading: true });
                    this.props.onContinue();
                  }}
                  isDisabled={!isButtonEnabled}
                  isLoading={this.state.isLoading}
                >
                  Continue
                </Button>{" "}
              </Center>
            </Box>
          </Card>
        </Center>
      </Box>
    );
  }
}

export default liveCheck;
